module.exports = __webpack_public_path__ + "static/the-skimm-logo.16801367.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/the-skimm-logo.svg
// module id = 507
// module chunks = 35783957827783